import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { PolicyEmail } from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage
      title="Cookie and storage policy"
      intro="This policy describes cookies, local browser storage, and related technologies used by the slayfulpawsco storefront."
    >
      <h2>What these technologies are</h2>
      <p>
        Cookies are small text files stored by a browser. Local storage is a
        similar browser feature that can retain information on a device without
        sending it with every web request. Server logs and pixels can also
        record technical events. We use the term “storage technologies” for
        these tools together where appropriate.
      </p>

      <h2>Current storefront use</h2>
      <table>
        <thead>
          <tr>
            <th>Technology or provider</th>
            <th>Purpose</th>
            <th>Typical duration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>cartItems</code> local storage</td>
            <td>Remembers product identifiers, options, quantities, and the contents of your shopping cart.</td>
            <td>Until you clear site data or the browser removes it.</td>
          </tr>
          <tr>
            <td>Hosting and security logs</td>
            <td>Delivers the site, diagnoses errors, limits abuse, and protects the service.</td>
            <td>According to operational and legal need.</td>
          </tr>
          <tr>
            <td>Third-party payment checkout</td>
            <td>Processes payment and helps detect fraudulent transactions after you choose to pay.</td>
            <td>Set by the payment provider under its notice.</td>
          </tr>
          <tr>
            <td>Hosted fonts and static resources</td>
            <td>Loads the fonts or interface assets used to display the site; the provider may receive request data such as an IP address and browser details.</td>
            <td>Controlled by the browser and provider.</td>
          </tr>
        </tbody>
      </table>

      <h2>Optional analytics and advertising</h2>
      <p>
        The current storefront does not intentionally configure optional
        analytics or advertising trackers. If optional technologies are added,
        this policy and any consent controls will be updated before they are
        used where consent is required.
      </p>

      <h2>Your controls</h2>
      <p>
        Browser settings can block or delete cookies and local storage. Doing so
        may empty the cart or prevent requested features from working. Privacy
        extensions and device settings may provide additional controls. Where
        legally required and technically supported, we treat recognized opt-out
        preference signals as a request for the browser that sends them.
      </p>

      <h2>Related information</h2>
      <p>
        See our <Link to="/privacy">Privacy Policy</Link> for the broader use of
        personal information and <Link to="/privacy-choices">Your Privacy
        Choices</Link> for request instructions. Questions can be sent to
        <PolicyEmail subject="Cookie or storage question" />.
      </p>
    </PolicyPage>
  );
}

export default CookiePolicy;
